import React, { useState, useEffect } from 'react';
import ResetPasswordModal from './ResetPasswordModal';
import './ResetPasswordPage.css';

const ResetPasswordPage = ({ onClose, onSuccess }) => {
  const [token, setToken] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Obtener token de la URL usando URLSearchParams nativo
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromUrl = urlParams.get('token');
    
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      setShowModal(true);
    } else {
      setError('Token de recuperación no válido o faltante');
    }
  }, []);

  const handleSuccess = () => {
    // Notificar éxito al componente padre
    if (onSuccess) onSuccess();
    // Cerrar modal después de éxito
    setTimeout(() => {
      if (onClose) onClose();
    }, 2000);
  };

  const handleClose = () => {
    // Cerrar y volver al inicio
    if (onClose) onClose();
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <div className="reset-password-header">
          <div className="logo">
            <i className="fas fa-leaf"></i>
            <span>JAVILAND</span>
          </div>
          <h1>Recuperación de Contraseña</h1>
          <p>Establece una nueva contraseña para tu cuenta</p>
        </div>

        {error ? (
          <div className="error-container">
            <div className="error-icon">
              <i className="fas fa-exclamation-triangle"></i>
            </div>
            <h2>Error</h2>
            <p>{error}</p>
            <button 
              className="btn-primary"
              onClick={handleClose}
            >
              <i className="fas fa-home"></i>
              Volver al Inicio
            </button>
          </div>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <i className="fas fa-spinner fa-spin"></i>
            </div>
            <p>Preparando formulario de recuperación...</p>
          </div>
        )}

        {/* Modal de nueva contraseña */}
        <ResetPasswordModal
          isOpen={showModal}
          onClose={handleClose}
          token={token}
          onSuccess={handleSuccess}
        />
      </div>
    </div>
  );
};

export default ResetPasswordPage;
